module.exports = __webpack_public_path__ + "static/media/frame.944ada09.svg";